import { useEffect } from "react";

export const APP_NAME = "Galaxy One";

/**
 * Formats screen title into: `${screenName} - Galaxy One`
 * If screenName is empty or equals APP_NAME, returns `Galaxy One`.
 */
export function formatPageTitle(screenName?: string | null): string {
  const name = screenName?.trim();
  if (!name || name === APP_NAME) {
    return APP_NAME;
  }
  return `${name} - ${APP_NAME}`;
}

/**
 * Sets document.title directly on browser tab.
 */
export function setDocumentTitle(screenName?: string | null): void {
  if (typeof document !== "undefined") {
    document.title = formatPageTitle(screenName);
  }
}

/**
 * Hook to synchronize current screen name with browser tab title.
 */
export function useDocumentTitle(screenName?: string | null): void {
  useEffect(() => {
    setDocumentTitle(screenName);
  }, [screenName]);
}
